import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimOwnershipLog.List.IRequest;
type Response = Api.Core.ClaimOwnershipLog.List.IResponse;
type Headers = Api.Core.ClaimOwnershipLog.List.IHeaders;
const url = '/api/Claims/ClaimOwnershipLog';
export default async function claimOwnershipLogListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
